import { SVGProps } from 'react';

function LocationIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={props.width}
      height={props.height}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M7 1.667A4.08 4.08 0 0 0 2.917 5.75C2.917 8.813 7 13.333 7 13.333s4.083-4.52 4.083-7.583A4.08 4.08 0 0 0 7 1.667ZM4.083 5.75a2.918 2.918 0 0 1 5.834 0c0 1.68-1.68 4.194-2.917 5.763-1.213-1.557-2.917-4.1-2.917-5.763Z'
        fill={props.fill}
      />
      <path d='M7 7.208a1.458 1.458 0 1 0 0-2.916 1.458 1.458 0 0 0 0 2.916Z' fill={props.fill} />
    </svg>
  );
}

export default LocationIcon;
